import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@tcp/cloudia-utilities';

@Component({
  selector: 'cloudia-cookie-settings-modal',
  templateUrl: './cookie-settings-modal.component.html',
  styleUrls: ['./cookie-settings-modal.component.scss'],
})
export class CookieSettingsModalComponent
  extends BaseComponent
  implements OnInit
{
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
